import * as React from 'react';
import { useIntl } from 'react-intl';
import { CmdModal } from '@commander-services/gui-components';
import { IVehicleFuelCardCell } from '../types';
import FuelCardsList from './FuelCardsList';
import useAnalytics from '../../../hooks/useAnalytics';
import { getTableName } from '../../CmdTable/CmdTableService';
import { VEHICLE_SETTINGS_TABLE_KEY } from '../constants';

interface ChipsCellWithModalProps {
  data: IVehicleFuelCardCell[];
  id: string;
  align?: string;
}

function ChipsCellWithModal({ data, align = 'center', id }: ChipsCellWithModalProps) {
  const { formatMessage: f } = useIntl();
  const [isOpenModal, setIsOpenModal] = React.useState(false);
  const { trackEvent } = useAnalytics();

  const handleOpenModal = (event) => {
    event.preventDefault();

    setIsOpenModal(true);
    trackEvent([`table ${getTableName(VEHICLE_SETTINGS_TABLE_KEY)}`, 'click', 'Open fuel cards modal']);
  };
  const handleClose = () => {
    setIsOpenModal(false);
  };

  return (
    <>
      {isOpenModal && (
        <FuelCardsList fuelCards={data} handleCloseModal={handleClose} />
      )}
      <div
        className={`text-cell align-${align}`}
        style={{ flex: 1, cursor: 'pointer' }}
        data-cy={`chips-table-vehicle-settings-${id}`}
        onClick={handleOpenModal}
        key={id}
      >
        <div className="e-table-label">
          {/* <i className={`cmd-icon ${handleIconClass(data)}`} /> */}
          {f({ id: 'table_list.columns.fuelCards' })}: {Object.keys(data).length}
        </div>
      </div>
    </>
  );
}

export default ChipsCellWithModal;
